export default {
	global : {
		name:"Name",
		bookings : 'Bookings',
		operation : 'Operation',
		operationAssignment : 'Assignment',
		import: 'Import',
		importReservations: 'Import Reservations',
		importReservation: 'Import Reservation',
		downloadFormat: 'Download Format',
		downloadFormatClean:"Empty format",
		downloadFormatExample:"Format with example",
		validateInformation: 'Validate information',
		typesServices: 'Type of services',
		file: 'File',
		dateFormat: 'Date format',
		timeFormat: 'Time format',
		operationTracking : 'Real time operation',
		tracking:"Tracking",
		transportUnits : 'Fleet',
		users : 'Users',
		drivers : 'Drivers',
		profile : 'Profile',
		logout : 'Logout',
		all : 'All',
		selectAll : 'Select all',
		clean : 'Clean',
		search : 'Search',
		firstName : 'First Name',
		lastName : 'Last Name',
		save : 'Save',
		yes: 'Yes',
		filters: 'Filters',
		registerDeleted: 'Deleted successfully',
		serverError: 'The server no response',
		filterByService: 'Filter by service',
		filteringByService: 'It is filtering by service',
		ajaxTable:{
			noRecordsFound:'No records found',
			selectAll:'Select All',
			showingNRecords:'Showing {from} to {to} records of {total}',
			massiveOperationsOn: 'Enable bulk operations',
			massiveOperationsOff: 'Disable bulk operations',
			assignConfirmation: 'Assign confirmation',
			orderBy:"Order by"
		},
		status: 'Status',
		actions: 'Actions',
		copy: 'Copy',
		minutes: 'minutes',
		after: 'after',
		before: 'before',
		ofFlight: 'flight',
		delete: 'Delete',
		add: 'Add',
		phone : 'Phone',
		email : 'Email',
		cancel : 'Cancel',
		update: 'Update',
		description: 'Description',
		change: 'Change',
		upload: 'Upload',
		info: 'Information',
		image: 'Image',
		pos: 'POS',
		selectOption:'Select an option',
		errorsFound: 'The following errors were encountered while processing file:',
		GenerateReservations: 'Generate reservations',
		errorsFoundAlert: 'Errors were found in the file, please verify data',
		successfullyRegistered: 'Successfully registered reservations',
		supplier: 'Supplier',
		pointOfSale: 'Point Of Sale',
		dashboard:'Dashboard',
		reports:"Reports",
		seeLocation:"See location",
		changes: 'Changes',
		idChange: 'ID change',
		date: 'Date',
		user: 'User',
		changeType: 'Change type',
		field: 'Field',
		new: 'New',
		edit: 'Edit',
		correctlyAdded: "Added correctly",
		confirmMovePlaceToMap:"¿Are you sure you want to manually select the location:",
		placesNotDiscovered:"Following places could not be discovered",
		moveToPendingToMap:"Move to pending to map",
		createBookings:"Generate reservations",
		modules:"Settings",
		toEdit:"Edit",
		doneSuccessfully: "saved successfully",
		shared:"shared",
		private:"Privated",
		registeredSuccess:"Saved successfully",
		manage:"Manage",
		serviceTypes:"Service types",
		saveYourChanges:"Save your changes",
		allFeaturesAlert: "Reach out to discover how to access all the features.",
		restore:"Restore",
		prices:"Prices",
		salesChannels:"Sale channels",
		genericError:"Something went wrong"
	},
	warnings : {
		okToContinue : 'Confirm action',
		continue : 'Continue',
		cancel : 'Cancel',
		processing : 'Processing',
	},
	bookings : {
		passengers: 'Passengers',
		notAccepted: 'Pending',
		clientName:'Client name',
		airports:'Airports',
		general:'General',
		destinations:'Destinations',
		salesReference:'Sales channel ID',
		supplierConfirmed: 'Confirmed Service',
		referenceId:'Supplier confirmation',
		serviceType:'Service type',
		serviceStatus:'Service status',
		pickupConfirmed:'Pickup confirmed',
		serviceDateFrom:'Service date from',
		serviceDateTo:'Service date to',
		transportUnit:'Vehicle',
		driver:'Driver',
		trackingStatus:'Tracking status',
		tracking: 'Tracking',
		trackingService: 'Tracking of service',
		serviceStatusOpts:{
			active:		'Active',
			pending:	'Pending',
			noShow:		'No Show',
			noProvided:	'Not provided',
			canceled:	'Cancelled',
			done:		'Done',
			partialCancellation: 'Partial Cancellation',
		},
		trackingStatusOpts:{
			pending:'Ready to start',
			onWayToPickup:'On way to pickup',
			atPickup:'At pickup',
			onWayToDropoff:'On way to dropoff',
			finished:'Finished',
			noShow:'No show',
		},
		reservationStatusOpts:{
			active:'Active',
			canceled:'Cancelled',
		},
		confirmed:'Confirmed',
		noConfirmed:'No confirmed',
		cancelDateFrom:'Cancelation date from',
		cancelDateTo:'Cancel date to',
		tripType:'Trip type',
		client:'Client',
		pickupDate:'Pickup date',
		trip:'Trip',
		actions:'Actions',
		export:'Export',
		booking:'Booking',
		clientInfo:'Client info',
		adults:'Adults',
		kids:'Childrens',
		infants:'Infants',
		service:'Service',
		status:'Status',
		origin:'Origin',
		destination:'Destination',
		route:'Route',
		dateTimeAndNumberOf:'Date, time and number of',
		arrivalFlight:'Arrival Flight',
		departureFlight:'Departure Flight',
		pickupDatetime:'Pickup date & time',
		confirmData:'Confirm data',
		before:'before',
		after:'after',
		supplierNotes:'Supplier notes',
		flight:'flight',
		minutes:'minutes',
		serviceUpdatedSuccessfully:'Service Updated Successfully',
		noShowEvidences:'No Show evidences',
		noShowEvidenceMessage:'To change the service status to <strong>NO SHOW</strong>, please upload the corresponding proofs, which show that the driver and / or staff is at the scheduled time and pick-up location.',
		doneEvidenceMessage:'To change the service status to <strong>DONE</strong>, please upload the corresponding proofs, which show that the driver and / or staff is at the scheduled time and pick-up location.',
		accepted:'Accepted',
		shuttleCentralService:'Shuttle Central B2B',
		selfService:'Direct sell',
		rejectService:'Reject service',
		notes:'Notes',
		salesChannel:'Sales Channel',
		salesChannelReference:'Sales Channel Reference',
		salesChannelTitle:"Sale Channel Title",
		noShow:'No Show',
		noProvided:'Not Provided',
		cancel:'Cancel',
		done:'Done',
		partialCancellation: 'Partial Cancellation',
		confirm:'Confirm',
		copyRes:'Copy booking',
		createdBy:'Created by',
		reservationDate:'Booking date',
		canceledBy:'Cancelled by',
		cancelationDate:'Cancelation date',
		validate:'Validate',
		addService:'Add service',
		cancelRes:'Cancel booking',
		acceptService:'Accept service',
		servicesFrom: 'Services from',
		servicesTo: 'to',
		clickFlightInfo:'Clic to see flight information',
		flightNotValidate:'Flight not validate',
		newRes:'New Booking',
		paxes:'Passengers',
		pickup:'Origin',
		dropoff:'Destination',
		transportInfo:'Service info',
		makeBooking:'Book',
		Accepted: 'Accepted Rides',
		AcceptedOptions: {
			all: 'All',
			pending: 'Pending to confirm',
			confirmed: 'Confirmed'
		},
		AcceptedOptionsMassive: {
			rejected: 'Reject',
			confirmed: 'Confirm'
		},
		asignMsgPartial: "$TOTAL services could not be updated as they were previously accepted. If you require additional attention please contact the operations staff",
		asignMsg: 'Successful upgrade',
		emptyStateSelect: 'No state selected.',
		acceptReject: "Accept/Reject service",
		confirmAcceptService:"Are you sure you want to CONFIRM the service?",
		confirmRejectService : "Are you sure you want to REJECT the service?",
		selectServiceMassive: "No service selected",
		confirmSupplierConfirmationMassive:"Are you sure you want to %{action} the selected services?",
		assignDriverUnit: 'Driver & vehicle assigment',
		assign: 'Assign',
		unassignedServices:'UNASSIGNED services',
		assignedServices:'Assigned services',
		reviews: 'Reviews',
		withoutCommentsOnReview: 'The client left no comments',
		price: 'Rate',
		points: 'Points',
		assignDriverDefault: 'Assign driver default',
		useFlightData:"Set flight data",
		flightScheduleNoAvailable:'Schedule no available',
		rateOverride: "Set and lock rate",
		usePreviousMap: "Use previous data",
		internalReference:"Internal Reference",
		keyword:"Keyword",
		rateLocked:"Rate locked",
		clientNote: "Client notes"
	},
	users : {
		newUser:'New user',
		newDriver:'New driver',
		name:'Name',
		email:'Email',
		access:'Access',
		status:'Status',
		actions:'Actions',
		editingUser:'Editing user',
		editingDriver:'Editing driver',
		firstName:'First name',
		lastName:'Last name',
		phone:'Phone',
		userInfo:'User info',
		language:'Language',
		accessTypeOpts : {
			master : 'Master',
			admin : 'Admin',
			operation : 'Operation',
			driver : 'Driver',
		},
		license:'License',
		profilePicture:'Profile picture',
		profile:'Profile',
		msgRegistered: 'User added successfully',
		msgUpdate: 'User updated successfully',
		msgRemoved: 'User deleted successfully',
		password: 'Password',
		resetPassword: "Reset password",
		newPassword : 'New Pasword',
		repeatPassword : 'Repeat Password',
		updatedPassword : 'Updated Password',
		passwordAreDifferent : 'Password are different'
	},
	profile : {
		firstName : 'First name',
		lastName : 'Last name',
		email : 'Email',
		phone : 'Phone',
		language : 'Language',
		changePassword : 'Change Pasword',
		newPassword : 'New Pasword',
		repeatPassword : 'Repeat Password',
		updatePassword : 'Update Password',
		updatedPassword : 'Updated Password',
		passwordAreDifferent : 'Password are different',
		updatedData : 'Updated data',
		changeSass: 'Change platform',
	},
	transportUnits : {
		newUnit: 'Add Vehicle',
		name: 'Name',
		plateNumber: 'Plate Number',
		unitBrand: 'Brand',
		unitModel: 'Model',
		unitModelYear: 'Year',
		maxPassengers: 'Vehicle capacity',
		editUnit: 'Vehicle edition',
		info: 'Information',
		unitPhoto: 'Vehicle picture',
	},
	driver : {
		myServices:'My Services',
		changeUnit:'Change vehicle',
		noPermission: "Don't have location permissions, activate permission for this page on your device",
		howAndroid: "How to do ANDROID",
		acceptPermission: "Click and accept location permission",
		findLocation: "Click to find your location",
		withoutDriverData: "Without driver data"
	},
	AssignConfirmation: {
		oktitle: 'Confirm Reservation',
		title: 'Assign Confirmation',
		rowsMessage: 'You have selected $TOTAL reservations to update',
	},
	transportServiceChangeStatus: {
		note: 'Register a quick note*',
		btnUpdate: 'Update Status',
		btnUpdateProcess: 'Processing',
		btnCancel: 'Cancel',
		title: 'Upload Support for new Status',
	},
	transportServiceStatus: {
		pending:	'Pending',
		active:		'Active',
		noShow:		'No show',
		noProvided:	'Not provided',
		canceled:	'Cancelled',
		done:		'Done',
		success:	'Successfully updated service',
		partialCancellation: 'Partial Cancellation',
		activeDoneNoShow:"Active+Done+No Show",
	},
	filesRelated: {
		emptyImg: 'You haven’t uploaded any images yet',
		fileDelete: 'File deleted',
		notSelectImg: 'You have not selected an image',
		uploadedFile: 'Uploaded file',
	},
	confirm: {
		Yes: true,
		No: false
	},
	statusOptions: {
		active: 'Active',
		pending: 'Pending'
	},
	statusActive: {
		active: 'Active',
		inactive: 'Inactive'
	},
	accessTypes: {
		/*master: 'Master',*/
		admin: 'Administrator',
		operation: 'Operation',
		driver: 'Driver',
	},
	langOptions: {
		es: 'Spanish',
		en: 'English',
	},
	alerts:{
		trackingStatusChanged:"The service : {serviceNumber} has been changed to: {trackingStatus} "
	},
	dashboard:{
		startDate:"Start date",
		endDate:"End date",
		compareBy:"Compare by:",
		day:"Day",
		week:"Week",
		month:"Month",
		year:"Year",
		volumenAssigned:"Assigned rides",
		volumenAccepted:"Accepted rides",
		volumenRejected:"Rejected rides",
		ridesPerStatus:"My operation",
		hideShowDataLabels:"Show/Hide data labels",
		driverPerformance:"Drivers performance",
		myRides:"My rides",
		reviewPerDate: "Reviews per date"
	},
	reports:{
		myRevenue:"My revenue",
		datesValidation:"Date inputs are required",
		currency:"Currency",
		rate:"$ Rate",
		referenceData:"The information below is subject to adjustments as the status of your operation and rides is updated.",
		rangeLimit:"Limit Exceeded ({days} days max. per request)",
		reviewes: 'Reviewes',
		editRates:"Edit Rates",
		saveRates:'Save Rates',
		calculateRate:'Calculate rate',
		rateNotFound:"Rate no found"
	},
	rto:{
		drivers: "GPS Drivers",
		lastConnection:"Last connection"
	},
	messages: {
		driverAssigned: "This data will be distributed (En. booking.com)",
		errorTrackingModule: "Cannot load because the ride information is incorrect, try saving changes before entering the module.",
		chatNotAvailable: "Chat not available"
	},
	validations: {
		nameRequired: "Nombre es requerido",
		lastNameRequired: "Apellido es requerido",
		phoneRequired: "Phone es requerido",
		emailRequired: "Email es requerido"
	},
	tracking: {
		driverChat: 'Driver Chat',
		localTime: 'Local time'
	},
	history: {
		id: "Id",
		reservationId: "Reservation Id",
		pickupPlaceId: "Pickup",
		dropoffPlaceId: "Dropoff",
		supplierId: "Supplier",
		salesChannelId: "Sale channel",
		serviceTypeId: "Service type",
		creationUserId: "Creation user",
		supplierReference: "Supplier reference",
		salesChannelReference: "Sales channel reference",
		supplierNotes: "Supplier notes",
		flightNumber: "Flight number",
		flightDatetime: "Flight date time",
		pickupDatetime: "Pickup date time",
		bookingPriceSubtotal: "Booking price subtotal",
		netPriceSubtotal: "Net price Subtotal",
		supplierPriceSubtotal: "Supplier price subtotal",
		creationDatetime: "Creation date time",
		cancelDatetime: "Cancel date time",
		cancelUserId: "Cancel user",
		contactStatus: "Contact Status",
		consecutiveId: "Consecutive Id",
		pickupDatetimeConfirmed: "Pickup date time confirmed",
		bookingPriceTotal: "Booking price total",
		netPriceTotal: "Net price total",
		supplierPriceTotal: "supplier price total",
		pointOfSaleId: "Point of sale",
		clientPickupPlaceId: "Client pickup place",
		clientDropoffPlaceId: "Dropoff client",
		salesChannelReservationReference: "Sales channel reservation ref.",
		source: "Source",
		flightValidationStatus: "Flight validation status",
		flightValidationData: "Flight validation data",
		userDriverId: "Driver",
		transportUnitId: "Transport Unit",
		supplierSalesChannel: "Supplier sales channel",
		trackingStatus: "Tracking status",
		supplierConfirmation: "Supplier confirmation",
		supplierCurrency: "Supplier currency",
		pickupDatetimeUtc: "pickup date time UTC",
		status: "Status",
		checkinStatus: "Checkin status",
		travelTime: "Travel time",
		travelLength: "Travel lenght",
		clientNote: "Client note",
		bookingCurrency: "Booking currency",
		netCurrency: "Net currency",
		ratePlanId: "Rate plan",
		paymentStatus: "Payment status",
		ticket: "Ticket",
		carrierCode: "Carrier code",
		flightNumberValidation: "Flight number validation",
		actualFlightDatetime: "Actual flight date time",
		reasonStateId: "Reason state",
		ratePlanData: "Rate plan data",
		bookingPriceOverride: "Booking price override",
		netPriceOverride: "Net price override",
		supplierPriceOverride: "Supplier price override",
		supplierServiceTypeId: "Supplier service type",
		supplierPromoData: "Supplier promo data",
		revisedUserId: "Revised user",
		revisedAt: "Revised at",
		supplierAssignedAt: "Supplier assigned at",
		serviceTypeCategoryId: "Service type category",
		pickupZoneId: "Pickup zone",
		dropoffZoneId: "Dropoff zone",
		salesChannelPromoData: "Sales channel promo data",
		promoCode: "Promo code",
		reviewId: "Review",
		accessType: "Access type",
		firstName: "First name",
		lastName: "Last name",
		email: "Email",
		phone: "Phone",
		updated_at: "Updated at",
		created_at: "Created at",
		paymentTotal: "Payment total",
		operatedBy: "Operated By",
		clientId: "Client",
		adults: "Adults",
		children: "Children",
		infants: "Infants",
		reservationDatetime: "Reservation date time",
		promoApplied: 'Promo Applied',
		promoData: 'Promo Data'
	},
	saleChannel:{
		new:"New Sales Channel",
		edit:"Edit Sales Channel",
		name:"name",
		code:"code",
		saleChannel:"Sales Channels",
		confirmDelete: "Are you sure you want to delete the sale channel: {saleChannel} ?"

	},
	zonedArea:{
		operationZones: "Operation Areas",
		new: "New Operation Area",
		zones:"Zones",
		restore:"Restore",
		priority:"Priority",
		goToList:"Go to list",
		confirmDelete:"This Operation Area has already been saved in the system, if you delete it all rate plans connected will be affected",
		confirmDeleteZone:"This zone has already been saved in the system, if you delete a zone all costs charged for that zone will be deleted",
		detailsAndEdit:"Details and edit, manage zones"
	},
	serviceType:{
		module:"Service Types",
		new:"New service type",
		name:"Name",
		code:"Codigo",
		maxPax:"Max Pax",
		maxSuiteCases:"Max suitecases",
		category:"Vehicle category",
		description:"Description",
		serviceType:"Service type",
		edit:"Edit service type",
		confirmDelete:"Are you sure you want to DELETE the service type: {serviceType}"
	},
	ratePlan:{
		data:"Rate Plan data",
		currency:"Currency",
		operationArea:"Operation area",
		startDate:"Start date",
		endDate:"End date",
		showZonedAreaSelected:"Show operation area selected",
		confirmDelete:"If you delete this rate plan ({ratePlanName}), all prices loaded in this rate plan will be deleted",
		summary:"Summary",
		selectOrigin:"Select origin",
		selectDestination:"Select destination",
		msjPrice0:"**Prices at 0 means that the service is not allowed",
		applyOpposite:"Apply costs to transportation on the opposite trip",
		selectFromAndTo: "Select <b>From</b> and <b>To</b> to continue..."
	},
	assignation:{
		assigned:"Assigned",
		selectDrivertoContinue: "Select driver",
		operation: "Logistic",
		noRides:"No rides assigned yet",
		summary:"Summary",
		assignChange:"Assign/Change driver"
	},
	timeline: {
		historyChanges: "Changelog",
		lastChangesSubtitle: "Changes since the last service confirmation.",
		lastChange: "Last change",
		changeType: "Change type:",
		changes: "Changes",
		dateChange: "Date of change",
		clientChange: "Change made by client",
		systemChange: "Change made by system",
		refresh: "Refresh"
	}
}
